export const SOCKET = process.env.REACT_APP_SOCKET_URL
export const API = process.env.REACT_APP_API_URL
export const PRODUCT_CODE = process.env.REACT_APP_PRODUCT_CODE
export const PRODUCT_NAME = process.env.REACT_APP_PRODUCT_NAME
